<template>
  <div class="hello">
    <br />
    <table width="720" border="0" align="center" cellpadding="0" cellspacing="0" :background="require('../assets/img/games/runawayrobot/bg.jpg')" style="color:white;">
  <tr>
    <td height="30"><span class="style3">Runaway Robot</span></td>
  </tr>
  <tr>
    <td height="198" align="center"><img src="../assets/img/games/runawayrobot/banner.jpg" width="712" height="198" /></td>
  </tr>
  <tr>
    <td height="322" valign="top"><table width="700" border="0" align="center" cellpadding="0" cellspacing="0">
        <tr>
          <td width="350">&nbsp;</td>
          <td width="350">&nbsp;</td>
        </tr>
        <tr>
          <td><p class="style26">Have you ever wished you had your very own robot? You could teach it to do your chores and fetch the mail. You could even make it clean your room. </p>
              <p class="style26">If you did have your own robot, you would quickly find out that telling a robot what to do is quite tricky. One wrong command and he might just run into the fireplace. That's the idea behind Runaway Robot. You are given a series of tasks to accomplish with your robot. It is up to you to tell your robot how to solve the puzzle and reach the exit.</p></td>
          <td valign="top"><br />
              <table width="320" border="0" align="center" cellpadding="0" cellspacing="0" background="../assets/img/games/runawayrobot/whitespot.jpg">
                <tr>
                  <td width="77" height="50" align="center"><img src="../assets/img/games/runawayrobot/bg0_icon.jpg" width="64" height="48" border="0" /></td>
                  <td width="140"><span class="style27 style30">Training Mission<br />
                        <span class="style29">(10 easy levels)</span></span></td>
                  <td width="100" align="center"><router-link to="/games/runawayrobottraining"><img src="../assets/img/playsm.jpg" width="83" height="18" border="0" /></router-link></td>
                </tr>
              </table>
            <br />
              <table width="320" border="0" align="center" cellpadding="0" cellspacing="0" background="../assets/img/games/runawayrobot/whitespot.jpg">
                <tr>
                  <td width="78" height="50" align="center"><router-link to="/games/runawayrobotkey"><img src="../assets/img/games/runawayrobot/bg1_icon.jpg" width="64" height="48" border="0" /></router-link></td>
                  <td width="140"><span class="style27 style30">The Key is the Key<br />
                        <span class="style29">(10  levels)</span></span></td>
                  <td width="100" align="center"><router-link to="/games/runawayrobotkey"><img src="../assets/img/playsm.jpg" width="83" height="18" border="0" /></router-link></td>
                </tr>
              </table>
            <br />
              <table width="320" border="0" align="center" cellpadding="0" cellspacing="0" background="../assets/img/games/runawayrobot/whitespot.jpg">
                <tr>
                  <td width="78" height="50" align="center"><router-link to="/games/runawayrobotteleport"><img src="../assets/img/games/runawayrobot/bg2_icon.jpg" width="64" height="48" border="0" /></router-link></td>
                  <td width="140"><span class="style27 style30">Teleport Resort<br />
                        <span class="style29">(10  levels)</span></span></td>
                  <td width="100" align="center"><router-link to="/games/runawayrobotteleport"><img src="../assets/img/playsm.jpg" width="83" height="18" border="0" /></router-link></td>
                </tr>
              </table>
            <br />
              <table width="320" border="0" align="center" cellpadding="0" cellspacing="0" background="../assets/img/games/runawayrobot/whitespot.jpg">
                <tr>
                  <td width="78" height="50" align="center"><router-link to="/games/runawayrobotlocks"><img src="../assets/img/games/runawayrobot/bg3_icon.jpg" width="64" height="48" border="0" /></router-link></td>
                  <td width="140"><span class="style27 style30">Locks!<br />
                        <span class="style29">(10  levels)</span></span></td>
                  <td width="100" align="center"><router-link to="/games/runawayrobotlocks"><img src="../assets/img/playsm.jpg" width="83" height="18" border="0" /></router-link></td>
                </tr>
            </table></td>
        </tr>
    </table></td>
  </tr>
</table>


    <div @click="goBack()">Go Back</div>
  </div>
</template>

<script>
export default {
  name: 'RunawayRobotMenu',
  props: {
    msg: String
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    gameClick(game){
      console.log("launching "+game);
      this.$router.push(game);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
